import { render, staticRenderFns } from "./PrivateNote.vue?vue&type=template&id=02d7e237&scoped=true&"
import script from "./PrivateNote.vue?vue&type=script&lang=js&"
export * from "./PrivateNote.vue?vue&type=script&lang=js&"
import style0 from "./PrivateNote.vue?vue&type=style&index=0&id=02d7e237&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02d7e237",
  null
  
)

export default component.exports